module.exports = __webpack_public_path__ + "fonts/LidlFontCondPro-Semibold.woff2";